import { FC } from 'react';

import { useSearchPersist } from '@/components/DataGrid/hooks/useSearchPersist';
import MasterVehicleForm from '@/layouts/TabLayout/MasterVehicles/components/MasterVehicleForm';
import { IMasterName, IMasterVehicleForm } from '@/models';
import MasterIndexVehicleBase from '@/pages/MasterIndex/Vehicles/components/MasterIndexVehicleBase';

export interface MasterVehicleFormData
  extends Omit<IMasterVehicleForm, 'owner'> {
  owner?: IMasterName;
}

const MasterIndexVehicleForm: FC = () => {
  const { navigateWithSearch } = useSearchPersist();

  return (
    <MasterIndexVehicleBase>
      <MasterVehicleForm
        goBack={() => navigateWithSearch('/master-index/vehicles')}
        hideHeader={true}
        isMasterIndex={true}
      />
    </MasterIndexVehicleBase>
  );
};

export default MasterIndexVehicleForm;
